import React, { Fragment, useEffect, useState, useRef, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Alert } from '@interstate/components/Alert';
import { AuxButton } from '@interstate/components/Button';
import { Typography } from '@interstate/components/Typography';

import * as offerSelectors from '@makemydeal/dr-dash-store/selectors/offerSelectors';
import * as paymentSelectors from '@makemydeal/dr-dash-store/selectors/payment';

import { BannerWrapper } from '../Banner.interstate.style';
import DroppedFeesList from './components/DroppedFeesList';

const DroppedFeesBanner: React.FC = () => {
    const [showBanner, setShowBanner] = useState(false);
    const applicationName = useSelector(offerSelectors.getApplicationName);
    const isPaymentsCalculated = useSelector(paymentSelectors.getPaymentsCalculated);

    const droppedFeesRaw = useSelector(offerSelectors.getDroppedFees);

    const hasBannerShown = useRef(false);

    const shouldShowBanner = useMemo(() => {
        return applicationName === 'Desking' && isPaymentsCalculated && droppedFeesRaw.length > 0 && !hasBannerShown.current;
    }, [applicationName, isPaymentsCalculated, droppedFeesRaw.length]);

    useEffect(() => {
        if (shouldShowBanner) {
            setShowBanner(true);
            hasBannerShown.current = true;
        }
    }, [shouldShowBanner]);

    const handleBannerDismiss = () => {
        setShowBanner(false);
    };

    if (droppedFeesRaw.length === 0) {
        return null;
    }

    return (
        <Fragment>
            {showBanner && (
                <BannerWrapper className="isBaseDeal">
                    <Alert type="caution" key="alert-dropped-fees" role="" data-testid="alert-dropped-fees">
                        <Typography variant="body-sm">
                            The following fees were dropped from the deal because the system could not automatically map these fees:
                        </Typography>

                        <DroppedFeesList fees={droppedFeesRaw} />

                        <Typography variant="body-sm">
                            Please add them to the deal if needed.
                            <AuxButton data-testid="cta-button-dropped-fees" onClick={handleBannerDismiss}>
                                Okay, Got It
                            </AuxButton>
                        </Typography>
                    </Alert>
                </BannerWrapper>
            )}
        </Fragment>
    );
};

export default DroppedFeesBanner;
